<template>
  <layout title="Classrooms">
    <div class="row">
      <div class="col-10">
        <h2 class="page-heading">
          <inertia-link
            class="previous-path-header"
            :href="route('classrooms.index')"
          >
            Classrooms
          </inertia-link>
          / {{ form.name }}
        </h2>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="card shadow-sm p-3 mb-5 bg-white rounded mt-2">
          <div class="card-body col-md-8">
            <div class="row">
              <div class="col-md-12 mt-4">
                <form @submit.prevent="update">
                  <div class="form-group row">
                    <label for="name" class="col-sm-2 col-form-label">
                      Name
                    </label>
                    <div class="col-sm-10">
                      <input
                        type="text"
                        class="form-control"
                        id="name"
                        placeholder="Tenant name"
                        v-model="form.name"
                      />
                      <div
                        v-if="errors && errors.name"
                        class="d-block invalid-feedback"
                      >
                        {{ errors.name }}
                      </div>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="name" class="col-sm-2 col-form-label">
                      Description
                    </label>
                    <div class="col-sm-10">
                      <textarea
                        class="form-control"
                        id="description"
                        rows="5"
                        v-model="form.description"
                      />
                      <div
                        v-if="errors && errors.description"
                        class="d-block invalid-feedback"
                      >
                        {{ errors.description }}
                      </div>
                    </div>
                  </div>

                  <h4 class="mt-5">Course &amp; Teacher</h4>
                  <hr />

                  <div class="form-group row">
                    <label for="name" class="col-sm-2 col-form-label">
                      Course
                    </label>
                    <div class="col-sm-10">
                      <span class="form-control">
                        {{ classroom.data.course.name }}
                      </span>
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="name" class="col-sm-2 col-form-label">
                      Teacher
                    </label>
                    <div class="col-sm-10">
                      <select class="form-control" v-model="form.teacher_id">
                        <option value=""></option>
                        <option
                          v-for="teacher in teachers"
                          :key="teacher.id"
                          :value="teacher.id"
                          :selected="teacher.id == form.teacher_id"
                        >
                          {{ `${teacher.first_name} ${teacher.last_name}` }}
                        </option>
                      </select>
                      <div
                        v-if="errors && errors.teacher_id"
                        class="d-block invalid-feedback"
                      >
                        {{ errors.teacher_id }}
                      </div>
                    </div>
                  </div>

                  <div class="form-group row">
                    <div class="col-sm-12">
                      <button type="submit" class="btn btn-primary float-right">
                        Save
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import AppLayout from "../Layouts/AppLayout";
import { onMounted } from "vue";

export default {
  setup() {
    onMounted(() => {
      const hash = location.hash;
      const accepted_hashes = ["#data", "#students"];

      if (hash && accepted_hashes.includes(hash)) {
        $(`#formTab a[href="${hash}"]`).tab("show");
      }
    });
  },
  layout: AppLayout,
  props: {
    errors: Object,
    classroom: Object,
    teachers: Object,
    assigned_students: Object,
    unassigned_students: Object,
  },
  data() {
    return {
      form: {
        name: this.classroom.data.name,
        description: this.classroom.data.description,
        teacher_id: this.classroom.data.teacher
          ? this.classroom.data.teacher.id
          : null,
      },
    };
  },
  methods: {
    update() {
      this.$inertia.patch(
        route("classrooms.update", this.classroom.data.id),
        this.form
      );
    },
  },
};
</script>
